<template>
  <div>
    <van-nav-bar title="考勤异常申请" left-text="返回" right-text="" @click-left="onClickLeft"/>
    <van-form class="login-form-top">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="考勤异常规则说明" name="1" icon="calendar-o">
          <div style="color: red" v-html="this.tips"></div>
        </van-collapse-item>
      </van-collapse>
      <!--      <van-radio-group v-model="errorRadio">-->
      <!--        <van-cell-group>-->
      <!--          <van-cell :title="errorTitle(item)" clickable v-for="item in errorList" :key="item.id"-->
      <!--                    clickable @click="errorRecord(item)">-->
      <!--            <template slot="right-icon">-->
      <!--              <van-radio :name="item.id" @click="errorRecord(item)"></van-radio>-->
      <!--            </template>-->
      <!--          </van-cell>-->
      <!--        </van-cell-group>-->
      <!--      </van-radio-group>-->
      <!--      <van-field-->
      <!--        readonly-->
      <!--        clickable-->
      <!--        name="changeDay"-->
      <!--        :value="changeDay"-->
      <!--        label="异常日期"-->
      <!--        placeholder="点击选择日期"-->
      <!--        :rules="[{ required: true, message: '请选择异常日期' }]"-->
      <!--      />-->

      <van-field
        readonly
        clickable
        name="datetimePicker"
        :value="changeDate"
        label="异常时间"
        placeholder="点击选择时间"
        @click="showChangeDateTime = true"
      />
      <van-popup v-model="showChangeDateTime" position="bottom">
        <van-datetime-picker
          type="datetime"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onChangeDateTimeConfirm"
          @cancel="showChangeDateTime = false"
        />
      </van-popup>
      <van-field
        v-model="reason"
        rows="3"
        autosize
        label="原因"
        type="textarea"
        maxlength="50"
        placeholder="请填写原因"
        show-word-limit
      />
      <van-field name="applyFile" label="附件">
        <template slot="input">
          <van-uploader :before-read="beforeApplyFileRead" :after-read="afterApplyFileRead"
                        :max-size="5000 * 1024" max-count="6" v-model="showFiles" multiple
                        :before-delete="beforeApplyFileDelete"
                        accept="image/*,.pdf,.doc,.docx,.xml,.dwg,.ppt,.pptx,.txt,.xls,.xlsx,.zip,.rar">
          </van-uploader>
        </template>
      </van-field>
    </van-form>
<!--    <div style="margin: 16px;">-->
<!--      <van-button round block type="primary" native-type="submit" @click="taskSave">保存</van-button>-->
<!--    </div>-->
    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" @click="taskSubmit">提交</van-button>
    </div>

    <van-dialog v-model="roleShow" title="我的角色" show-cancel-button @confirm="roleCommit" confirmButtonText="提交">
      <van-radio-group v-model="roleRadio">
        <van-cell-group>
          <van-cell :title="item.roleName" clickable v-for="item in roleList" :key="item.roleAlias"
                    clickable @click="roleRadio = item.roleAlias">
            <template slot="right-icon">
              <van-radio :name="item.roleAlias"></van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
    <ProcessDialog ref="showProcessDialog" :submitFlowMethod="submitFlowMethod"
                   :getFlowParamsMethod="getFlowParamsMethod"/>
  </div>
</template>

<script>

import {Dialog, Toast} from "vant";
import Vue from "vue";
import moment from "moment";
import {isLogin, isWechat, replaceUrl} from "../../../utils/util";

export default {
  name: "userAttenceErrAppeal",
  data() {
    return {
      errorList: [],
      errorRadio: 0,
      activeNames: ['1'],
      taskId: '',
      processInstanceId: '',
      processDefinitionId: '',
      appNo: '',
      realName: '',
      deptName: '',
      userInfo: {},
      userAttenceErrId: 0,
      changeDay: '',
      changeDate: '',
      showChangeDateTime: false,
      showChangeDateCalendar: false,
      choseRoleId: '',
      nextProcess: false,
      minDate: new Date(2022, 0, 1),
      maxDate: new Date(2050, 0, 31),
      reason: '',
      showFiles: [],
      allFiles: {
        applyFiles: [],
        removedFiles: [],
      },
      applyFileIds: [],
      workYear: 0,
      roleShow: false,
      roleRadio: 0,
      roleList: [],
      pageType: 0,
      processShow: false,
      tips: '',
      modelKey: "UserAttenceErrAppeal",
      userAttenceErrForm: {},

    };
  },
  mounted() {
    if(!isLogin()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.appNo = this.$route.query.appNo;
    this.processInstanceId = this.$route.query.processInstanceId;
    this.taskId = this.$route.query.taskId;
    this.processDefinitionId = this.$route.query.processDefinitionId;
    this.userAttenceErrId = this.$route.query.userAttenceErrId;
    this.pageType = this.$route.query.pageType;
    this.minDate = new Date(moment().subtract(1, "months").year(),
      moment().subtract(1, "months").month(), 1)
    this.initUserInfo();
  },
  methods: {
    initUserInfo() {
      this.getUserInfo();
    },
    getUserInfo() {
      this.$fetch("/attence-api/blade-user/info", {}).then(
        res => {
          const user = res.data;
          this.realName = user.realName;
          this.deptName = user.deptName;
          this.userInfo = user;
          this.workYear = user.workYear;
          this.$fetch("/attence-api/blade-system/param/getSystemParam", {
            key: 'USER_ATTENCE_ERR_APPEAL_PROMPT'
          }).then(res => {
            const data = res.data;
            if (data != null) {
              this.tips = data;
            }
          });
          this.getInitData();
        },
        error => {

        }
      );
    },
    getInitData() {
      //如果当前流程已数据
      this.$fetch("/attence-api/blade-flow/process/userAttenceErrAppeal/flowDetailByFlowAppNo", {
        flowAppNo: this.appNo,
      }).then(res => {
        const data = res.data;
        if (data.id != undefined) {
          this.userAttenceErrId = data.id;
          this.reason = data.reason;
          this.allFiles = data.allFiles;
          this.showFiles = data.allFiles.applyFiles;
          this.changeDay = data.changeDate.split(" ")[0];
          let times = data.changeDate.split(" ")[1].split(":");
          this.changeDate = data.changeDate;
          this.showFiles.forEach(v => {
            this.applyFileIds.push(v.id);
            v.url = replaceUrl(v.viewUrl);
          });
          this.userAttenceErrForm = data;
        }
        // this.$fetch("/attence-api/blade-attendance-info/attendanceInfo/page", {
        //   attendanceResultIn: "X,◤,◥",
        //   empNo: this.userInfo.account,
        //   current: 1,
        //   size: 100,
        // }).then(res => {
        //   let result = res.data;
        //   this.errorList = result.records;
        //   if(this.errorList != null && this.errorList.length > 0){
        //     //循环当前list 选中之前填的日期
        //     this.errorList .forEach(ele => {
        //       if (this.changeDay == ele.workingTime){
        //         this.errorRecord(ele);
        //       }
        //     });
        //   }
        // });
      });
    },
    errorTitle(item) {
      let title = '班次：' + item.timeClassesName + "，日期：" + item.workingTime + "，上班打卡：" + item.attendanceBeginTime
        + "，下班打卡：" + item.attendanceEndTime + "，考勤状态：" + item.attendanceResult;
      return title;
    },
    errorRecord(item) {
      this.errorRadio = item.id;
      this.changeDay = item.workingTime;
    },
    onChangeDateTimeConfirm(time) {
      this.changeDate = moment(time).format("YYYY-MM-DD HH:mm") + ":00";
      this.showChangeDateTime = false;
    },
    onClickLeft: function () {
      let path = '';
      if (this.pageType == 0) {
        path = '/attenceflow/FlowList';
      } else {
        path = '/attenceflow/userAttenceErrAppeal/list';
      }
      this.$router.push({
        path: path,
        query: {}
      });
    },
    // 返回布尔值
    beforeApplyFileRead(file) {
      return true;
    },
    afterApplyFileRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      // 此时可以自行将文件上传至服务器
      console.log(file);
      let formData = new FormData();
      formData.append('file', file.file);
      formData.append('bizColumn', 'applyFiles');
      this.$filePost("/attence-api/blade-manager/bizAttach/upload", formData).then(
        res => {
          const data = res.data;
          file.status = 'done';
          file.message = '上传成功';
          this.applyFileIds.push(data.id);
          this.allFiles.applyFiles.push(data);
          console.log("IDS：" + JSON.stringify(data));
        },
        error => {
          file.status = 'failed';
          file.message = '上传失败';
        }
      );
    },
    beforeApplyFileDelete(file, detail) {
      let index = JSON.stringify(detail.index);
      let delId = this.applyFileIds[index];
      let url = "/attence-api/blade-manager/bizAttach/remove";
      this.$post(url, {
        ids: delId,
      }).then(
        res => {
          const data = res.data;
          this.applyFileIds.splice(index, 1);
          Toast('刪除成功');
          console.log("IDS：" + this.applyFileIds);
        },
        error => {
        }
      );
      return true;
    },
    taskSave() {
      if (this.changeDate == '') {
        Toast('请选择异常时间');
        return;
      }

      if (this.reason == '') {
        Toast('请填写原因');
        return;
      }
      const params = {
        applyUser: this.userInfo.id,
        id: this.userAttenceErrId,
        changeDate: this.changeDate,
        reason: this.reason,
        allFiles: this.allFiles,
        flowAppNo: this.appNo,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
      };
      this.userAttenceErrForm.applyUser = this.userInfo.id;
      this.userAttenceErrForm.id = this.userAttenceErrId;
      this.userAttenceErrForm.changeDate = this.changeDate;
      this.userAttenceErrForm.reason = this.reason;
      this.userAttenceErrForm.allFiles = this.allFiles;
      this.userAttenceErrForm.flowAppNo = this.appNo;
      this.userAttenceErrForm.processInstanceId = this.processInstanceId;
      this.userAttenceErrForm.processDefinitionId = this.processDefinitionId;
      this.userAttenceErrForm.flow = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
        variables: {
          notifyUserIds: '',
        },
      }
      this.$bodyPost("/attence-api/blade-flow/process/userAttenceErrAppeal/submit", this.userAttenceErrForm).then(resp => {
        Toast("数据保存成功");
        this.$router.push({
          path: "/attenceflow/userAttenceErrAppeal/list",
          query: {}
        });
      }, error => {

      });
    },
    taskSubmit() {
      if (this.changeDate == '') {
        Toast('请选择异常时间');
        return;
      }

      if (this.reason == '') {
        Toast('请填写原因');
        return;
      }

      this.$fetch("/attence-api/blade-user/getUserFlowRoleList", {}).then(res => {
        const data = res.data;
        this.roleList = [];
        data.forEach((v) => {
          if (v.roleFlow != undefined && v.roleFlow != "") {
            const flowLit = v.roleFlow.split("|");
            flowLit.forEach((flow) => {
              if (this.modelKey == flow) {
                this.roleList.push(v);
              }
            });
          }
        });
        if (this.roleList.length > 0) {
          if (this.roleList.length > 1) {//流程发起角色大于1个选择角色发起流程
            this.roleRadio = this.roleList[0].roleAlias;
            this.choseRoleId = this.roleList[0].roleAlias;
            this.roleShow = true;
          } else {
            this.choseRoleId = this.roleList[0].roleAlias;
            this.showProcessInfo();
          }
        } else {
          Toast('未配置流程发起角色，请联系统系管理员！');
        }
      });
    },
    roleCommit() {
      this.choseRoleId = this.roleRadio;
      this.showProcessInfo();
    },
    choseRoleSubmit() {
      const params = {
        applyUser: this.userInfo.id,
        id: this.userAttenceErrId,
        changeDate: this.changeDate,
        reason: this.reason,
        allFiles: this.allFiles,
        selectedRole: this.choseRoleId,
        flowAppNo: this.appNo,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
      };
      this.userAttenceErrForm.applyUser = this.userInfo.id;
      this.userAttenceErrForm.id = this.userAttenceErrId;
      this.userAttenceErrForm.changeDate = this.changeDate;
      this.userAttenceErrForm.reason = this.reason;
      this.userAttenceErrForm.allFiles = this.allFiles;
      this.userAttenceErrForm.selectedRole = this.choseRoleId;
      this.userAttenceErrForm.flowAppNo = this.appNo;
      this.userAttenceErrForm.processInstanceId = this.processInstanceId;
      this.userAttenceErrForm.processDefinitionId = this.processDefinitionId;
      this.userAttenceErrForm.flow = {
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        processDefinitionId: this.processDefinitionId,
        variables: {
          notifyUserIds: '',
        },
      }
      this.$bodyPost("/attence-api/blade-flow/process/userAttenceErrAppeal/start-process", this.userAttenceErrForm).then(resp => {
        const data = resp.data;
        Toast('流程提交成功');
        this.roleShow = false;
        this.processShow = true;
        this.jumpPage();
      });
    },
    jumpPage() {
      let path = '';
      if (this.pageType == 0) {
        path = '/attenceflow/FlowList';
      } else {
        path = '/attenceflow/userAttenceErrAppeal/list';
      }
      this.$router.push({
        path: path,
        query: {}
      });
    },
    showProcessInfo() {
      //展示对话框
      this.$refs.showProcessDialog.showProcessInfo();
      this.roleShow = false;
    },
    submitFlowMethod() {
      this.choseRoleSubmit();
    },
    getFlowParamsMethod() {
      //用于对话框展示请求接口参数
      const params = {
        businessId: this.userAttenceErrId,
        taskId: this.taskId,
        processInstanceId: this.processInstanceId,
        flag: 'ok',
        processDefinitionKey: this.modelKey,
        variables: {
          auditStatus: " ",
          roleType: this.choseRoleId,
        },
      };

      return params;
    },
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

.login-form-top {
  margin-top: 0px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/userAttenceErrAppeal/form.vue